'use client'

import { ReactNode } from 'react'

import { ItemPageGalleryPluginModel } from '../types'
import DesktopImageCarousel from './DesktopImageCarousel'
import MobileImageCarousel from './MobileImageCarousel'

type Props = {
  data: ItemPageGalleryPluginModel
  favouriteButton?: ReactNode
}

const ItemPageGalleryPluginNew = ({ data, favouriteButton }: Props) => {
  return (
    <>
      <section
        className="u-tablets-up-only desktop-image-gallery-plugin"
        data-testid="item-gallery-plugin-new"
      >
        <DesktopImageCarousel data={data} favouriteButton={favouriteButton} />
      </section>
      <section className="u-phones-only mobile-image-gallery-plugin">
        <MobileImageCarousel data={data} favouriteButton={favouriteButton} />
      </section>
    </>
  )
}

export default ItemPageGalleryPluginNew
